import { useEffect, useRef, useState } from 'react';

/** Keep the scrollbar gutter stable; reveal the thumb only while scrolling. */
export function useAutoHideScroll() {
  const [scrolling, setScrolling] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  useEffect(() => () => clearTimeout(timer.current), []);
  return {
    'data-scrolling': scrolling,
    onScroll: () => {
      setScrolling(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setScrolling(false), 900);
    },
  };
}
